export default __webpack_public_path__ + "img/Process.18f94b8.gif";